import React, { useState } from "react";
import { Lock } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function IndlangsProposal() {
  const [unlocked, setUnlocked] = useState(() => sessionStorage.getItem("indlangs_ok") === "1");
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/indlangs/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: pw }),
      });
      const d = await r.json();
      if (d.ok) {
        sessionStorage.setItem("indlangs_ok", "1");
        setUnlocked(true);
      } else {
        setError("Incorrect password");
      }
    } catch {
      setError("Connection error — try again");
    }
    setBusy(false);
  };

  if (!unlocked) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f4f6f9", fontFamily: "'Source Sans 3', system-ui, sans-serif", padding: "20px" }}>
        <form onSubmit={submit} style={{ background: "#fff", borderRadius: "16px", padding: "40px 36px", maxWidth: "400px", width: "100%", boxShadow: "0 8px 40px rgba(0,0,0,0.08)", textAlign: "center" }}>
          <Lock size={28} style={{ color: "#1d2a3f", marginBottom: "12px" }} />
          <h2 style={{ fontFamily: "'Baloo Tamma 2', system-ui", fontSize: "1.6rem", margin: "0 0 8px", color: "#1d2a3f" }}>Password Required</h2>
          <p style={{ fontSize: "14px", color: "#566176", margin: "0 0 24px" }}>Enter the password to view this proposal.</p>
          <input
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="Password"
            autoFocus
            data-testid="indlangs-password"
            style={{ width: "100%", padding: "12px 16px", borderRadius: "8px", border: "1px solid #d8dde6", fontSize: "15px", outline: "none", marginBottom: "12px", boxSizing: "border-box" }}
          />
          {error && <p style={{ color: "#c0392b", fontSize: "13px", margin: "0 0 12px" }} data-testid="indlangs-error">{error}</p>}
          <button
            type="submit"
            disabled={busy || !pw}
            data-testid="indlangs-submit"
            style={{ width: "100%", padding: "12px", borderRadius: "8px", background: "#1d2a3f", color: "#fff", fontSize: "15px", fontWeight: "600", border: "none", cursor: "pointer", opacity: busy || !pw ? 0.5 : 1 }}
          >
            {busy ? "Checking..." : "View Proposal"}
          </button>
        </form>
      </div>
    );
  }

  return (
    <iframe
      src="/indlangs-proposal-content.html"
      title="English through Kannada — Proposal"
      style={{ width: "100%", height: "100vh", border: "none" }}
      data-testid="indlangs-iframe"
    />
  );
}
